module.exports = __webpack_public_path__ + "assets/img/4.39ccb4ed.jpg";